module.exports = __webpack_public_path__ + "img/37.like.bcbfdb1e.svg";